<template>
    <div class="mt-1 space-y-2">
        <div v-for="(option, index) in options" :key="index">
            <button
                v-html="option"
                @click="$emit('select', option)"
                class="block w-full text-left py-1 px-2 bg-white rounded-md shadow-sm hover:shadow-md"
            ></button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['options'],
}
</script>